export const inRange = (num: number, start: number, end: number) => num >= start && num <= end;
